<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start">
                <strong>{{ $t('ChequeBooks') }}</strong>
              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0" @click="insert_data()"
                         type="submit" class="mr-1 ml-1"
                         size="sm" color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>
                <CButton v-if="status_form!=0" @click="emptyList()"
                         class="mr-1"
                         type="reset" size="sm" color="secondary">
                  {{ $t("buttons.cancel") }}
                </CButton>

              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol col="3">
                <CSelect
                    :label="$t('components.bankAccTitle')"
                    :options="bank_account_items"
                    :value.sync="selected_bank_account"
                    :horizontal="{label: 'col-sm-6', input: 'col-sm-6'}"

                />


              </CCol>
              <CCol col="3">
                <CInput
                    :label="$t('tables.bank')"
                    :horizontal="{label: 'col-sm-6', input: 'col-sm-6'}"
                    disabled
                    v-model="bank_name"

                />
              </CCol>
              <CCol col="3">
                <CInput
                    :label="$t('SortCode')"
                    v-model="sort_code"
                    disabled

                    :horizontal="{label: 'col-sm-6', input: 'col-sm-6'}"

                />

              </CCol>
              <CCol col="3">
                <CInput
                    :label="$t('AccountNo')"
                    disabled
                    v-model="account_no"

                    :horizontal="{label: 'col-sm-6', input: 'col-sm-6'}"

                />

              </CCol>

              <CCol col="3">
                <CInput
                    :label="$t('chequeBookNo')"
                    v-model="chequeBookNo"
                    :horizontal="{label: 'col-sm-6', input: 'col-sm-6'}"
                />
              </CCol>
              <CCol col="3">
                <CInput
                    :label="$t('StartSerialNumber')"
                    v-model="StartSerialNumber"
                    :horizontal="{label: 'col-sm-6', input: 'col-sm-6'}"
                />
              </CCol>
              <CCol col="3">
                <CInput
                    :label="$t('EndSerialNumber')"
                    v-model="EndSerialNumber"
                    :horizontal="{label: 'col-sm-6', input: 'col-sm-6'}"
                />
              </CCol>
              <CCol col="3">
                <CRow>
                  <CCol col="5" class="text-end">
                    <label class="text-end">{{ $t('tables.status') }}</label>
                  </CCol>
                  <CCol col="7">
                    <CIcon
                        @click.native="cheque_status = false"
                        v-if="cheque_status"
                        class="text-success" name="cil-check"/>
                    <CIcon
                        @click.native="cheque_status=true"
                        v-else
                        name="cil-check"/>
                  </CCol>
                </CRow>
              </CCol>

              <CCol col="6">
                <CInput
                    :label="$t('components.summary')"
                    :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"

                    v-model="description"

                />
              </CCol>


            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('ChequeBooks') }}</strong>
          </CCardHeader>
          <CCardBody>
            <CDataTable
                :items="cheque_items"
                :fields="fields"
                column-filter
                border
                striped
                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row="{item,index}">
                <td style="text-align: center">
                  <p>{{ index + 1 }}</p>
                </td>
              </template>
              <template #accountNo="{item,index}">
                <td style="text-align: center">
                  <p>{{ get_bank_property_by_id(item.accountId, 'accountNo') }}</p>
                </td>
              </template>
              <template #accountTitle="{item,index}">
                <td style="text-align: center">
                  <p>{{ item.accountTitle}}</p>
<!--                  <p>{{ get_bank_property_by_id(item.accountId, 'bankAccTitle') }}</p>-->
                </td>
              </template>


              <template #sortCode="{item}">
                <td style="text-align: center">
                  <p>{{ item.sortCode }}</p>
                </td>
              </template>
              <template #chequeBooksNo="{item}">
                <td style="text-align: right">
                  <p>{{ item.chequeBooksNo }}</p>
                </td>
              </template>
              <template #startSerialNo="{item}">
                <td style="text-align: right">
                  <p>{{ item.startSerialNo }}</p>
                </td>
              </template>
              <template #endSerialNo="{item}">
                <td style="text-align: right">
                  <p>{{ item.endSerialNo }}</p>
                </td>
              </template>

              <template #isActive="{item,index}">
                <td style="text-align: center">
                  <CIcon

                      v-if="item.isActive==1"
                      class="text-success" name="cil-check"/>
                  <CIcon

                      v-else
                      name="cil-check"/>
                </td>
              </template>

              <template #operation="{item}">
                <td>
                  <CIcon @click.native="edit_item(item)" class="text-warning" name="cilPencil"/>
                  <CIcon @click.native="delete_item_dialog(item)" class="text-danger"
                         name="cilTrash"/>
                </td>
              </template>


            </CDataTable>
          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
// import the styles

var items = [];


export default {
  name: 'Login',
  components: {},
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      cheque_status: true,
      validate_errors: [],
      name: '',
      sort_code: '',
      account_no: '',
      description: '',
      selected_branch: '',
      selected_bank: '',
      selected_bank_account: '',

      bank_name: "",
      bank_no: '',
      sheba_no: '',
      branch_items: [],
      bank_account_items: [],
      cheque_items: [],
      bank_items: [],
      selected_moein: 0,
      chequeBookNo: '',
      StartSerialNumber: '',
      EndSerialNumber: '',
      all_accounting_list: [],
      filtered_accounting_list: [],
      filtered_accounting_list_add: [],
      status_form: 0,
      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%'},
        {key: 'accountTitle', label: this.$t('tables.bankAccTitle'), _style: 'width:10%'},
        {key: 'bankName', label: this.$t('tables.bank'), _style: 'width:10%'},
        {key: 'sortCode', label: this.$t('SortCode'), _style: 'width:10%'},
        {key: 'accountNo', label: this.$t('AccountNo'), _style: 'width:10%'},

        {key: 'chequeBooksNo', label: this.$t('chequeBookNo'), _style: 'width:10%'},

        // {key: 'accountNo', label: this.$t('AccountNo'), _style: 'width:10%'},
        // {key: 'branchName', label: this.$t('tables.branch'), _style: 'width:10%'},
        {key: 'startSerialNo', label: this.$t('StartSerialNumber'), _style: 'width:10%'},
        {key: 'endSerialNo', label: this.$t('EndSerialNumber'), _style: 'width:10%'},
        {key: 'isActive', label: this.$t('tables.status'), _style: 'width:10%'},
        {key: 'operation', label: this.$t('tables.operation'), filter: false, _style: 'width:5%;'},
      ]
    }
  },
  created() {
  },
  computed: {},
  mounted() {
    this.$root.root_validate_errors = [];

    this.get_bank();
    this.get_branches();
    this.get_bank_accounts();
    this.get_lists_groups();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'selected_bank_account': function () {
      this.bank_name = this.get_bank_property('bankName');
      this.sort_code = this.get_bank_property('sortCode');
      this.account_no = this.get_bank_property('accountNo');
    },

  },
  methods: {
    get_bank_property(key) {
      if (this.bank_account_items.filter(x => x.id == this.selected_bank_account).length > 0) {
        return this.bank_account_items.filter(x => x.id == this.selected_bank_account)[0][key]

      } else {
        return ""
      }
    },
    get_bank_property_by_id(id, key) {
      if (this.bank_account_items.filter(x => x.id == id).length > 0) {
        return this.bank_account_items.filter(x => x.id == id)[0][key]

      } else {
        return ""
      }
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      return true
      if (this.selected_moein != 0 && this.selected_bank_account != 0
          && this.bank_no != '' && this.sheba_no != '' && this.name != '') {
        return true;
      }


      if (this.selected_branch == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectBranch'));
      }
      if (this.selected_bank_account == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectBank'));
      }
      if (this.bank_no == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertBankNo'));
      }
      if (this.sheba_no == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertSheba'));
      }
      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertBankName'));
      }

      return false;
      // e.preventDefault();
    },

    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    edit_item(item) {
      this.selected_bank_account = item.accountId
      // this.sort_code
      // this.account_no
      this.chequeBookNo = item.chequeBooksNo
      this.StartSerialNumber = item.startSerialNo
      this.EndSerialNumber = item.endSerialNo
      this.description = item.chequeDesc

      if (item.isActive == 1) {
        this.cheque_status = true
      } else {
        this.cheque_status = false
      }
      //
      // this.name = item.bankAccTitle;
      // this.description = item.summary;
      // this.selected_branch = item.branchId;
      // this.selected_bank_account = item.bankId;
      // this.bank_no = item.bankAccCode;
      // this.sheba_no = item.shabaNo;
      // this.cheque_status = item.isSale;
      // this.sort_code = item.sortCode;
      // this.account_no = item.accountNo;
      this.status_form = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.chequeBookNo = '';
      this.StartSerialNumber = '';
      this.EndSerialNumber = '';
      this.description = '';

      this.status_form = 0;

    },
    get_bank_accounts() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBankAccounts', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.bank_account_items = [{label: self.$t('select'), value: 0}]
          self.bank_account_items = self.sort_array(self.bank_account_items, content_data.data, 'id', 'bankAccTitle')
          if (self.bank_account_items.length > 0) {
            self.selected_bank_account = self.bank_account_items[0].id
          }
          self.get_cheque_books();

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_bank() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBanks', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.bank_items = [];
          self.bank_items = self.sort_array(self.bank_items, content_data.data, 'id', 'bankTitle')

          // content_data.data.forEach((val) => {
          //   var obj = {label: val.bankTitle, value: val.id}
          //
          //   self.bank_items.push(obj);
          // });
          // self.selected_bank = self.bank_items[0].value
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_cheque_books() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('ChequeBook/GetData', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          content_data.data.forEach(function (val) {

             val.accountTitle = self.get_bank_property_by_id(val.accountId, 'bankAccTitle')

          })
          self.cheque_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_branches() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBranchList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.branch_items = [];
          self.branch_items = self.sort_array(self.branch_items, content_data.data, 'branchId', 'branchTitle')

          // content_data.data.forEach((val) => {
          //   var obj = {label: val.branchTitle, value: val.branchId}
          //   self.branch_items.push(obj);
          // });
          self.selected_branch = self.branch_items[0].value

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    goToMembers(item) {

      this.$router.push({path: '/dashboard/accounting/sale-method-members/' + item.id});

    },

    insert_data() {

      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "ChequeBook/Add";
      } else {
        url = "ChequeBook/Update";
        formData.append('Id', this.status_form)

      }

      // formData.append('BankAccTitle', this.name);
      // formData.append('BankAccCode', this.bank_no);
      // formData.append('BranchId', this.selected_branch);
      // formData.append('ShabaNo', this.sheba_no);

      formData.append('AccountId', self.selected_bank_account);
      formData.append('BankId', this.bank_account_items.filter(x => x.id == this.selected_bank_account)[0].bankId);
      formData.append('SortCode', self.sort_code);
      formData.append('AccountNo', self.account_no);
      formData.append('ChequeBooksNo', self.chequeBookNo);
      formData.append('StartSerialNo', self.StartSerialNumber);
      formData.append('EndSerialNo', self.EndSerialNumber);
      if (this.cheque_status) {
        formData.append('IsActive', 1);

      } else {
        formData.append('IsActive', 0);

      }
      formData.append('ChequeDesc', this.description);


      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {

        self.status_form = 0;
        self.chequeBookNo = '';
        self.StartSerialNumber = '';
        self.EndSerialNumber = '';
        self.description = '';


        self.get_cheque_books();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {

      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.bankAccTitle]), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "ChequeBook/Delete";


      formData.append('Id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_cheque_books();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    get_lists_groups() {
      var self = this;
      self.items_parent = [];
      self.data_with_children = []

      const formData = new FormData();
      var url = "Get_AllAccountingGroups";
      // formData.append("MasterId", 0);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {


              self.all_accounting_list = response.data.data


              // console.log(self.data);
              response.data.data.forEach((val) => {
                if (val.parentId == 11) {

                  var obj = {
                    label: val.accountName,
                    name_code: val.accountName + " (" + val.accountCode + ")",
                    nature: val.nature,
                    type: val.type,
                    code: val.accountCode,
                    parentId: val.parentId,
                    value: val.id,
                    // children: self.get_childrens(val.id, response.data.data)


                  }

                  self.filtered_accounting_list.push(obj);
                  self.filtered_accounting_list_add.push(obj);


                }

              });
              self.selected_moein = self.filtered_accounting_list_add[0].value

              // self.filter_data()
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },

  }
}

</script>
